// extracted by mini-css-extract-plugin
export var alertIcon = "_ni-0";